import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { SquareObjectDataset } from 'app/model/dataset/square.dataset';
import { Metamodel } from 'app/model/base/model';
import { SquareLinkedService } from 'app/model/linkedservice/square.linkedservice';
import { format } from 'app/shared/utils/string.util';

export const squareObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(SquareObjectDataset).name,
    displayName: stringResources.Square_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(SquareLinkedService).name],
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
         stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
         stringResources.VersionLabel.toLocaleLowerCase()),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-square',
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-square'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    isTableNameRequired: `{ linkedService && linkedService.version === "v2" }`,
    notSupportCopySourceQuery: `{ linkedService && linkedService.version === "v2" }`,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
